setResolvers